// extracted by mini-css-extract-plugin
module.exports = {"zIndex":"notification_component_zIndex__3eZKY","anchor":"notification_component_anchor__IuFbn"};